import {
  WARRANTY_CLEAR_MODULE,
  WARRANTY_DELETE_DAMAGE,
  WARRANTY_UPDATE_MATERIAL_SUMMARY,
  WARRANTY_UPDATE_SINISTER_SUMMARY,
  WARRANTY_UPDATE_SINISTER_ID,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_ZIP_CODE,
  WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
  WARRANTY_UPDATE_PROPERTY_TYPE,
  WARRANTY_UPDATE_RESIDENT_TYPE,
  WARRANTY_UPDATE_COORDINATES,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_GET_REPORT,
  WARRANTY_GET_MATERIAL_SUMMARY,
  WARRANTY_GET_SINISTER,
  WARRANTY_GET_SINISTER_WOLOADER,
  WARRANTY_UPDATE_PROPS,
  UPDATE_LOADER,
  WARRANTY_GET_FORMS,
  WARRANTY_ADD_FORMS,
  WARRANTY_UPDATE_OBSERVATIONS,
  WARRANTY_UPDATE_ADDRESS,
  WARRANTY_GET_FINAL_LEVEL,
  WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
  WARRANTY_UPDATE_RESULT_DECLARATION,
  WARRANTY_GET_RESULT_DECLARATION,
  WARANTY_UPDATE_HAS_UPPTEC_DAMAGE,
  WARRANTY_UPDATE_ID,
  WARRANTY_UPDATE_FORMID,
  WARRANTY_UPDATE_SINID,
  WARANTY_UPDATE_REP_TYPE,
  WARANTY_UPDATE_WARRANTIES
} from '@/store/types'

import {
  apiGetDamage,
  apiDeleteDamage
} from '@/modules/Damage/services/damages'
import { apiGetReport } from '@/modules/Claim/services/reports'
import { apiGetMaterials } from '@/modules/Damage/services/gag'
import {
  apiGetSinister,
  apiPostSinister
} from '@/modules/Claim/services/sinister'
import {
  apiGetForm,
  apiGetLevelMobilierCategory
} from '@/modules/Damage/services/menus'

export default {
  [WARRANTY_GET_RESULT_DECLARATION]({ commit }, payload) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiGetReport(payload)
      .then((res) => {
        commit(WARRANTY_UPDATE_RESULT_DECLARATION, res.global_totals.gag)
        commit(WARANTY_UPDATE_HAS_UPPTEC_DAMAGE, res.sinister.has_upptec_damage)
        commit(WARANTY_UPDATE_REP_TYPE, res.sinister.rep_type)
        commit(WARANTY_UPDATE_WARRANTIES, res.warranties)
      })
      .finally(() => {
        commit(UPDATE_LOADER, false, { root: true })
      })
  },

  [WARRANTY_GET_FINAL_LEVEL]({ commit }, payload) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiGetLevelMobilierCategory(payload)
      .then((resp) => {
        commit(WARRANTY_UPDATE_CATEG_FINAL_LEVEL, resp.is_final_level)
        commit(UPDATE_LOADER, false, { root: true })
        return { formsUpdated: true }
      })
      .catch(() => {
        commit(WARRANTY_UPDATE_CATEG_FINAL_LEVEL, {})
        commit(UPDATE_LOADER, false, { root: true })
        return { formsUpdated: false }
      })
  },
  [WARRANTY_GET_FORMS]({ commit }, payload) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiGetForm(payload.report, payload.warrantyId)
      .then((forms) => {
        commit(WARRANTY_ADD_FORMS, forms)
        commit(UPDATE_LOADER, false, { root: true })
        return { formsUpdated: true }
      })
      .catch(() => {
        commit(WARRANTY_ADD_FORMS, {})
        commit(UPDATE_LOADER, false, { root: true })
        return { formsUpdated: false }
      })
  },
  [WARRANTY_GET_SINISTER_SUMMARY]({ state, commit }, payload) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiGetDamage(payload)
      .then((damages) => {
        if (damages) {
          commit(WARRANTY_UPDATE_SINISTER_SUMMARY, damages)
        }
      })
      .finally(() => {
        commit(UPDATE_LOADER, false, { root: true })
      })
  },
  [WARRANTY_DELETE_DAMAGE]({ state, dispatch }, payload) {
    const sinisterId = payload.sinisterId
    const damageId = payload.damageId
    return apiDeleteDamage(sinisterId, damageId)
  },
  [WARRANTY_GET_REPORT]({ state, commit }, payload) {
    return apiGetReport(state.sinisterId)
      .then((report) => {
        commit(WARRANTY_UPDATE_REPORT, payload)
        return report
      })
      .catch(() => {
        commit(WARRANTY_UPDATE_REPORT, {})
      })
  },
  [WARRANTY_GET_MATERIAL_SUMMARY]({ state, commit }) {
    return apiGetMaterials(state.sinisterId)
      .then((materials) => {
        commit(WARRANTY_UPDATE_MATERIAL_SUMMARY, materials)
      })
      .catch(() => {
        commit(WARRANTY_UPDATE_MATERIAL_SUMMARY, {})
      })
  },
  [WARRANTY_GET_SINISTER_WOLOADER]({ state, commit, dispatch }, payload) {
    return apiGetSinister(payload)
      .then((sinister) => {
        commit(WARRANTY_UPDATE_SINISTER_ID, payload)
        commit(WARRANTY_UPDATE_ZIP_CODE, sinister.zip_code)
        commit(
          WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
          sinister.more_than_two_years !== null ? sinister.more_than_two_years : ''
        )
        commit(WARRANTY_UPDATE_PROPERTY_TYPE, sinister.real_estate ? sinister.real_estate : '')
        commit(WARRANTY_UPDATE_RESIDENT_TYPE, sinister.declarant ? sinister.declarant : '')
        commit(WARRANTY_UPDATE_COORDINATES, {
          lat: parseFloat(sinister.lat),
          lng: parseFloat(sinister.lon)
        })
        if (sinister.observations !== null) {
          commit(WARRANTY_UPDATE_OBSERVATIONS, sinister.observations)
        }
        if (sinister.address !== null) {
          commit(WARRANTY_UPDATE_ADDRESS, sinister.address)
        }
        commit(UPDATE_LOADER, false, { root: true })

        return { isSinisterFound: true }
      })
      .catch(() => {
        commit(WARRANTY_CLEAR_MODULE)
        commit(WARRANTY_UPDATE_SINISTER_ID, payload)
        return { isSinisterFound: false }
      })
  },
  [WARRANTY_GET_SINISTER]({ state, commit, dispatch }, payload) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiGetSinister(payload)
      .then((sinister) => {
        commit(WARRANTY_UPDATE_SINISTER_ID, payload)
        commit(WARRANTY_UPDATE_ZIP_CODE, sinister.zip_code)
        commit(
          WARRANTY_UPDATE_MORE_THAN_TWO_YEARS,
          sinister.more_than_two_years !== null ? sinister.more_than_two_years : ''
        )
        commit(WARRANTY_UPDATE_PROPERTY_TYPE, sinister.real_estate ? sinister.real_estate : '')
        commit(WARRANTY_UPDATE_RESIDENT_TYPE, sinister.declarant ? sinister.declarant : '')
        commit(WARRANTY_UPDATE_COORDINATES, {
          lat: parseFloat(sinister.lat),
          lng: parseFloat(sinister.lon)
        })
        if (sinister.observations !== null) {
          commit(WARRANTY_UPDATE_OBSERVATIONS, sinister.observations)
        }
        if (sinister.address !== null) {
          commit(WARRANTY_UPDATE_ADDRESS, sinister.address)
        }

        commit(UPDATE_LOADER, false, { root: true })

        return { isSinisterFound: true }
      })
      .catch(() => {
        commit(WARRANTY_CLEAR_MODULE)
        commit(WARRANTY_UPDATE_SINISTER_ID, payload)
        commit(UPDATE_LOADER, false, { root: true })
        return { isSinisterFound: false }
      })
  },
  [WARRANTY_UPDATE_PROPS]({ state, commit }) {
    commit(UPDATE_LOADER, true, { root: true })
    return apiPostSinister(
      state.sinisterId,
      state.zipCode,
      state.moreThanTwoYears,
      state.propertyType,
      state.residentType,
      state.coordinates.lat,
      state.coordinates.lng,
      state.address,
      state.observations
    )
      .catch((errorCode) => {
        return { error: errorCode }
      })
      .finally(() => {
        commit(UPDATE_LOADER, false, { root: true })
      })
  },

  [WARRANTY_UPDATE_FORMID]({ state, commit }, payload) {
    commit(WARRANTY_UPDATE_ID, payload)
  },
  [WARRANTY_UPDATE_SINID]({ state, commit }, payload) {
    commit(WARRANTY_UPDATE_SINISTER_ID, payload)
  }
}
